import '../../../themes/global.scss';

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Column, Screen } from '@tempmee/react';
import { BackButton } from '~/commonComponents';
import { NoScreen } from '~/components/shared/NoScreen';
import { fetchTodayJobs } from '../../../actions';
import { Table } from './Table';

export const TodayJobs = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchTodayJobs({ page: 1 }));
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <NoScreen>
      <Screen.Header start={<BackButton />} title="Today's Professionals" />
      {/* NoScreen centers its children, so the list needs to claim the full width itself
          (the Screen body card used to do it). */}
      <Column width="100%">
        <Table />
      </Column>
    </NoScreen>
  );
};
